<template>
  <footer>
    <ContainerRedX>
      <section class="container pt-5 pb-5 text-white">
        <div class="row">
          <div class="col-sm-4 mt-5 justify-content-center d-flex align-items-center">
            <div class="col-10 pb-4">
              <img src="../assets/logo/w-x@4x.png" alt="" />
            </div>
          </div>

          <div class="col-sm-6" v-if="sharedState.cityInfo.endereco.cidade !== 'Araripina'">
            <div class="row">
              <div class="col-sm-6">
                <h4 class="bold mb-4 md-title text-white">S.A.C.</h4>
                <h5 class="foot-tel m-0">
                  <i class="material-icons mr-1">phone</i>
                  <span class="pb-2 md-title">{{ sharedState.cityInfo.fixo }}</span>
                </h5>

                <h4 class="bold mb-3 md-title text-white">Endereço</h4>
                <h5 class="foot-tel mt-1">
                  <i class="material-icons mr-1">location_on</i>
                  <span class="flex-column d-flex">
                    <span class="pb-2 md-title">{{
                      `${sharedState.cityInfo.endereco.local}, ${sharedState.cityInfo.endereco.numero}`
                    }}</span>
                    <span class="pb-2 md-title">{{
                      `${sharedState.cityInfo.endereco.bairro}, ${sharedState.cityInfo.endereco.cidade}-${sharedState.cityInfo.endereco.uf}`
                    }}</span>
                    <span class="pb-2 md-title">CEP: {{ sharedState.cityInfo.endereco.cep }}</span>
                  </span>

                </h5>
              </div>

              <div class="col-sm-6">
                <h4 class="bold mb-4 md-title text-white">Contato</h4>
                <h5 class="foot-tel m-0">
                  <i class="material-icons mr-1">email</i>
                  <span class="pb-2 md-title">virtex@virtex.com.br</span>
                </h5>

                <h4 class="bold mb-4 md-title text-white">Ouvidoria</h4>
                <h5 class="foot-tel m-0">
                  <i class="material-icons mr-1">email</i>
                  <span class="pb-2 md-title">ouvidoria@virtex.com.br</span>
                </h5>
              </div>

            </div>


          </div>
          <!-- Informações de Contato para Araripina!! -->
          <div class="col-sm-6" v-if="sharedState.cityInfo.endereco.cidade === 'Araripina'">

            <div class="row">
              <div class="col-sm-6">
                <h4 class="bold mb-3 md-title text-white">S.A.C.</h4>
                <h5 class="foot-tel m-0">
                  <!-- <i class="material-icons mr-1">phone</i> -->
                  <span class="pb-2 md-title">{{ sharedState.cityInfo.fixo.split(",")[0] }}</span>
                </h5>
                <h5 class="foot-tel m-0">
                  <!-- <i class="material-icons mr-1">phone</i> -->
                <span class="pb-2 md-title">{{ sharedState.cityInfo.fixo.split(",")[1] }}</span>
                </h5>
              </div>


              <div class="col-sm-5">
                <h4 class="bold mb-3 md-title text-white">Ouvidoria</h4>
                <h5 class="foot-tel m-0">
                  <i class="material-icons mr-1">email</i>
                  <span class="pb-1 md-title">ouvidoria@virtex.com.br</span>
                </h5>
              </div>
            </div>



           <!-- <h4 class="bold mb-3 md-title text-white">Financeiro<Q/h4>
              <h5 class="foot-tel m-0">
                <span class="pb-2 md-title">{{sharedState.cityInfo.whatsapp.split(",")[0]}}</span>
              </h5>
            <h4 class="bold mb-3 md-title text-white">Comercial</h4>
              <h5 class="foot-tel m-0">
                <span class="pb-2 md-title">{{sharedState.cityInfo.whatsapp.split(",")[1]}}</span>
              </h5> -->
            <h4 class="bold mb-3 md-title text-white">Endereço</h4>
            <h5 class="foot-tel mt-1">
              <i class="material-icons mr-1">location_on</i>
              <span class="flex-column d-flex">
                <span class="pb-2 md-title">{{
                  `${sharedState.cityInfo.endereco.local}, ${sharedState.cityInfo.endereco.numero}`
                }}</span>
                <span class="pb-2 md-title">{{
                  `${sharedState.cityInfo.endereco.bairro}, ${sharedState.cityInfo.endereco.cidade} - ${sharedState.cityInfo.endereco.uf}`
                }}</span>
                <span class="pb-2 md-title">CEP: {{ sharedState.cityInfo.endereco.cep }}</span>
              </span>
            </h5>
          </div>
          <div class="col-sm-4">
            <h4 class="bold md-title mb-2 text-white">Certificações de Qualidade</h4>
            <a
              target="_blank"
              href="
https://melhorplano.net/premio/melhor-internet-banda-larga/pi/picos"
              title="Maior Satisfação"
            >
              <img
                class="adesivo-footer"
                src="../assets/misc/Selo-Maior-Satisfao.svg"
                alt="Selo Maior Satisfacao"
                width="150"
                height="150"
              />
            </a>

            <a
              target="_blank"
              href="
https://melhorplano.net/premio/melhor-internet-banda-larga/pi/picos"
              title="Vencedor Melhor Provedor"
            >
              <img
                class="adesivo-footer"
                src="../assets/misc/Selo-Melhor-Provedor.svg"
                alt="Selo Melhor Provedor"
                width="150"
                height="150"
              />
            </a>

            <a
              target="_blank"
              href="
https://melhorplano.net/premio/melhor-internet-banda-larga/pi/picos"
              title="Vencedor Melhor Velocidade"
            >
              <img
                class="adesivo-footer"
                src="../assets/misc/Selo-Melhor-Velocidade.svg"
                alt="Selo Melhor Velocidade"
                width="150"
                height="150"
              />
            </a>

            <a
              target="_blank"
              href="http://validador.ipv6.br/index.php?lang=pt&site=www.virtex.com.br&uri=referer"
            >
              <img
                width="98"
                class="adesivo-footer mt-2"
                style="margin-left: 10px"
                alt="Este S&iacute;tio Web &eacute; acess&iacute;vel via IPv6!"
                src="../assets/icon/banipv61branco.png"
              />
            </a>

            <a
              target="_blank"
              href="https://www.manrs.org/isps/participants/entry/2035/"
            >
              <img
                class="adesivo-footer mt-2"
                style="margin-left: 10px;width: 70px"
                alt="Protect our customers and contribute to a safer internet by facilitating network operation"
                src="../assets/misc/MANRS.png"
              />
            </a>
          </div>
        </div>
      </section>
    </ContainerRedX>
    <BarEndSite></BarEndSite>
  </footer>
</template>

<script>
import ContainerRedX from "./ContainerRedX";
import BarEndSite from "./BarEndSite";
export default {
  name: "FooterBotton",
  components: { BarEndSite, ContainerRedX },
  data() {
    return {
      sharedState: this.$store.state
    };
  }
};
</script>

<style lang="scss">
.foot-tel {
  display: flex;
}

.adesivo-footer {
  width: 100px;
  margin-left: 10px;
  filter: drop-shadow(1px 1px 3px rgba(0, 0, 0, 0.42));
}
</style>
